export default function ErrorIcon({
  color = '#b32237',
  width = 10,
  height = 10,
  style = {},
}) {
  return (
    <svg
      height={height}
      width={width}
      style={{ ...style }}
      viewBox="0 0 97.72 97.72"
      >
      <path style={{ fill: color }} d="M0,48.86A48.86,48.86,0,1,1,48.86,97.72,48.86,48.86,0,0,1,0,48.86Z" />
      <path style={{ fill: '#fff' }} d="M49.12,64.43a8,8,0,1,1-8,8A8,8,0,0,1,49.12,64.43Z" />
      <path style={{ fill: '#fff' }} d="M49.12,56.49c-3,0-5.06-2.53-5.41-5.41L41.07,27.15c-.46-4.14,3.91-8,8-8s8.4,3.91,7.94,8L54.41,51.08C54.07,54,52.11,56.49,49.12,56.49Z" />
    </svg>
  );
}
